import { intervalToDuration } from 'date-fns'

export const formateDistanceToNow = (endDate: Date) => {
  const now = new Date()
  const { days, hours, minutes, seconds } = intervalToDuration({ start: now, end: endDate });

  return `${days && days > 0 ? days + 'd' : ''} ${hours}h ${minutes}m ${seconds}s`
}